// Инициализация попапа для филиалов yandex map
import mapTemplate from './templates/filials-map-container.handlebars';
import mapTemplateMobile from './templates/filials-map-container_mobile.handlebars';

app.modules.mapFilial = (function (self) {
  const _isMobile = app.config.isMobile;

  function _initPopup(target) {
    const templateTypeMap = {
      mapTemplate,
      mapTemplateMobile,
    };
    const container = document.createElement('div');
    const filialsContainer = target.closest('.js-firm-filials');
    const mainFilialCoordinatesData =
      filialsContainer.querySelector('.js-coordinates')?.dataset;
    const mainFilialParams = {};

    Object.keys(mainFilialCoordinatesData).forEach(function (key) {
      try {
        mainFilialParams[key] = JSON.parse(mainFilialCoordinatesData[key]);
      } catch (error) {
        mainFilialParams[key] = mainFilialCoordinatesData[key];
      }
    });

    container.innerHTML = templateTypeMap[
      _isMobile && target.dataset.openInsidePopup
        ? 'mapTemplateMobile'
        : 'mapTemplate'
    ]({productId: app.config.productId, ...mainFilialParams});

    _isMobile && !target.dataset.openInsidePopup
      ? _createInlineMap(filialsContainer, container, target)
      : _createPopupMap(container);
  }

  function _createPopupMap(container) {
    app.modules.modalDialog.create({
      content: container,
      dialogClass: 'filials-map-popup',
      showUiHeader: _isMobile,
      title: app.config.isMobile && app.i18n.companyAbout.showMap,
      open: _triggerYandexMapApi,
    });
  }

  function _createInlineMap(filialsContainer, container, target) {
    document.querySelector('.js-contacts-map') && _destroyMap();
    filialsContainer.append(container);
    _triggerYandexMapApi();
    _toggleButton(target, 'textinactive');
  }

  function _triggerYandexMapApi() {
    document.dispatchEvent(
      new CustomEvent('getYandexMapApi', {detail: 'popup'})
    );
  }

  function _toggleButton(button, value) {
    button.innerText = button.dataset[value];
    button.classList.toggle('js-open-map-filial-popup-active');
  }

  function _destroyMap(
    target = document.querySelector('.js-open-map-filial-popup-active')
  ) {
    window.Maps.getMap().destroy();
    document.querySelector('.js-contacts-map').remove();
    _toggleButton(target, 'textactive');
  }

  function _initMap() {
    const map = document.querySelector('.js-yandex-map-popup');
    if (!map) {
      return;
    }
    window.Maps.init(map.dataset);
  }

  function _listeners() {
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target.classList.contains('js-open-map-filial-popup')) {
        return;
      }
      if (_isMobile) {
        target.classList.contains('js-open-map-filial-popup-active')
          ? _destroyMap(target)
          : _initPopup(target);
        return;
      }
      _initPopup(target);
    });
    document.addEventListener('loadYandexMapApi:popup', _initMap);
  }

  self.load = _listeners;
  return self;
})(app.modules.initYandexMapPopup || {});
